import React from 'react';
import './FeedbackSection.css';
import { feedbacks } from '../../assets/exports';
import { FaQuoteLeft } from 'react-icons/fa';

const FeedbackSection = () => {
  return (
    <section className="feedback-section">
      <div className="feedback-section-wrapper">
        <h2 className="feedback-section-title">What People Say</h2>
        <div className="feedback-section-grid">
          {feedbacks.map((item, index) => (
            <div className="feedback-section-card" key={index}>
              <FaQuoteLeft className="feedback-section-quote-icon" />
              <p className="feedback-section-message">"{item.message}"</p>
              <div className="feedback-section-author">
                <span className="feedback-section-name">{item.name}</span>
                <span className="feedback-section-role">{item.role}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeedbackSection;
